import {
	handleActions
} from 'redux-actions';
import Immutable from 'immutable';

const OrderState = Immutable.fromJS({
	order: {
		orderId: '',
		sOrderDate: '',
		customerId: '',
		caseNumber: '',
		caseName: '',
		caseOfficer: '',
		sales: '',
		sDueDate: '',
		note: '',
		noteDisplay: '',
		customerName: '',
		phone: '',
		fax: '',
		address: '',
		winningTenderer: '固巧快實業有限公司' //預設值
	},
	orderValidation: {
		orderId: {
			validationState: null,
			helpBlock: null
		},
		sOrderDate: {
			validationState: null,
			helpBlock: null
		},
		customerId: {
			validationState: null,
			helpBlock: null
		},
		caseNumber: {
			validationState: null,
			helpBlock: null
		},
		caseName: {
			validationState: null,
			helpBlock: null
		},
		caseOfficer: {
			validationState: null,
			helpBlock: null
		},
		sales: {
			validationState: null,
			helpBlock: null
		},
		sDueDate: {
			validationState: null,
			helpBlock: null
		},
		note: {
			validationState: null,
			helpBlock: null
		},
		noteDisplay: {
			validationState: null,
			helpBlock: null
		},
		winningTenderer: {
			validationState: null,
			helpBlock: null
		}
	},
	orderDetail: {
		orderId: '',
		sOrderDetailId: '',
		gearName: '',
		customerGearName: '',
		modelName: '',
		specIdHasLabel: '',
		specIdNoLabel: '',
		sQuantity: '',
		gearAliasName: ''
	},
	orderDetailValidation: {
		sOrderDetailId: {
			validationState: null,
			helpBlock: null
		},
		gearName: {
			validationState: null,
			helpBlock: null
		},
		customerGearName: {
			validationState: null,
			helpBlock: null
		},
		modelName: {
			validationState: null,
			helpBlock: null
		},
		specIdHasLabel: {
			validationState: null,
			helpBlock: null
		},
		specIdNoLabel: {
			validationState: null,
			helpBlock: null
		},
		sQuantity: {
			validationState: null,
			helpBlock: null
		}
	},
	alertStyle: null,
	alertMessage: null,
	showAddOrderModal: false,
	showEditOrderModal: false,
	showEditOrderDetailModal: false,
	showViewOrderModal: false,
	forInsert: true,
	step1Class: 'active',
	step2Class: 'default',
	step1Display: '',
	step2Display: 'none',
	specIds: [],
	showSpecIdHasLabel: 'none',
	showSpecIdNoLabel: '',
	allCustomerIds: [],
});

const orderReducer = handleActions({
	CHANGE_ORDER_VALUE: (state, { payload }) => {

		let order = state.get('order');
		return state.merge({
			order: order.set(payload.id, payload.value),
		})
	},
	ADD_ORDER: (state, { payload }) => {

		if (payload.statusCode === '0') {
			let order = state.get('order');
			let orderDetail = state.get('orderDetail');
			return state.merge({
				alertStyle: payload.data.alertStyle,
				alertMessage: payload.data.alertMessage,
				step1Class: 'default',
				step2Class: 'active',
				step1Display: 'none',
				step2Display: '',
				orderDetail: orderDetail.set('orderId', order.get('orderId')),
			})
		} else {
			return state.merge({
				order: payload.data.bean,
				orderValidation: payload.data.valBean,
				alertStyle: payload.data.alertStyle,
				alertMessage: payload.data.alertMessage,
			})
		}
	},
	EDIT_ORDER: (state, { payload }) => {
		return state.merge({
			order: payload.data.bean,
			orderValidation: payload.data.valBean,
			alertStyle: payload.data.alertStyle,
			alertMessage: payload.data.alertMessage,
		})
	},
	FIND_ORDER: (state, { payload }) => {
		return state.merge({
			order: payload.data
		})
	},
	ADD_ORDER_DETAIL: (state, { payload }) => {

		return state.merge({
			orderDetailValidation: payload.data.valBean,
			alertStyle: payload.data.alertStyle,
			alertMessage: payload.data.alertMessage,
		})
	},
	CHANGE_ORDER_DETAIL_VALUE: (state, { payload }) => {

		let orderDetail = state.get('orderDetail');
		return state.merge({
			orderDetail: orderDetail.set(payload.id, payload.value),
		})
	},
	FIND_ORDER_DETAIL: (state, { payload }) => {
		return state.merge({
			orderDetail: payload.data
		})
	},
	OPEN_ADD_ORDER_MODAL: (state, { payload }) => {
		return state.merge({
			forInsert: payload.forInsert,
			showAddOrderModal: true
		})
	},
	OPEN_EDIT_ORDER_MODAL: (state, { payload }) => {
		return state.merge({
			forInsert: payload.forInsert,
			showEditOrderModal: true
		})
	},
	OPEN_EDIT_ORDER_DETAIL_MODAL: (state, { payload }) => {
		let orderDetail = state.get('orderDetail');
		return state.merge({
			showEditOrderDetailModal: true,
			orderDetail: orderDetail.set('orderId', payload.orderId),
		})
	},
	OPEN_VIEW_ORDER_MODAL: (state, { payload }) => {
		return state.merge({
			showViewOrderModal: true
		})
	},
	FIND_GEARSPEC_IDS: (state, { payload }) => {
		return state.merge({
			specIds: payload.data
		})
	},
	FIND_ALL_CUSTOMERIDS: (state, { payload }) => {
		return state.merge({
			allCustomerIds: payload.data
		})
	},
	CHANGE_SHOW_SPECIDHASLABEL: (state, { payload }) => {
		let gearHasLabel = payload.data;
		let showSpecIdHasLabel = 'none';
		let showSpecIdNoLabel = '';
		if (gearHasLabel) {
			showSpecIdHasLabel = '';
			showSpecIdNoLabel = 'none';
		}
		return state.merge({
			showSpecIdHasLabel: showSpecIdHasLabel,
			showSpecIdNoLabel: showSpecIdNoLabel,
		})
	},
	CLOSE_ORDER_MODAL: (state, { payload }) => {
		return state.merge({
			order: {
				orderId: '',
				sOrderDate: '',
				customerId: '',
				caseNumber: '',
				caseName: '',
				caseOfficer: '',
				sales: '',
				sDueDate: '',
				note: '',
				customerName: '',
				phone: '',
				fax: '',
				address: '',
				winningTenderer: '固巧快實業有限公司' //預設值
			},
			orderValidation: {
				orderId: {
					validationState: null,
					helpBlock: null
				},
				sOrderDate: {
					validationState: null,
					helpBlock: null
				},
				customerId: {
					validationState: null,
					helpBlock: null
				},
				caseNumber: {
					validationState: null,
					helpBlock: null
				},
				caseName: {
					validationState: null,
					helpBlock: null
				},
				caseOfficer: {
					validationState: null,
					helpBlock: null
				},
				sales: {
					validationState: null,
					helpBlock: null
				},
				sDueDate: {
					validationState: null,
					helpBlock: null
				},
				note: {
					validationState: null,
					helpBlock: null
				},
				noteDisplay: {
					validationState: null,
					helpBlock: null
				},
				winningTenderer: {
					validationState: null,
					helpBlock: null
				}
			},
			orderDetail: {
				orderId: '',
				sOrderDetailId: '',
				gearName: '',
				customerGearName: '',
				modelName: '',
				specIdHasLabel: '',
				specIdNoLabel: '',
				sQuantity: '',
				gearAliasName: ''
			},
			orderDetailValidation: {
				sOrderDetailId: {
					validationState: null,
					helpBlock: null
				},
				gearName: {
					validationState: null,
					helpBlock: null
				},
				customerGearName: {
					validationState: null,
					helpBlock: null
				},
				modelName: {
					validationState: null,
					helpBlock: null
				},
				specIdHasLabel: {
					validationState: null,
					helpBlock: null
				},
				specIdNoLabel: {
					validationState: null,
					helpBlock: null
				},
				sQuantity: {
					validationState: null,
					helpBlock: null
				}
			},
			alertStyle: null,
			alertMessage: null,
			showAddOrderModal: false,
			showEditOrderModal: false,
			showEditOrderDetailModal: false,
			showViewOrderModal: false,
			forInsert: true,
			step1Class: 'active',
			step2Class: 'default',
			step1Display: '',
			step2Display: 'none',
		})
	}
}, OrderState);

export default orderReducer;


// WEBPACK FOOTER //
// ./src/reducers/orderReducer.js